/**
 * WhatsApp Utilities
 * 
 * Functions for creating WhatsApp links and formatting phone numbers for wa.me
 */

import { normalizePhoneForStorage } from './ddiUtils';

/**
 * Format a phone number for WhatsApp wa.me link
 * @param phone - Phone number (peut être formatado ou não)
 * @param countryCode - Country code (e.g., "BR", "US") para adicionar DDI se necessário
 * @returns Phone number sanitized for wa.me (digits only with DDI, no +) or null if invalid
 */
export function formatPhoneForWhatsApp(phone: string | null | undefined, countryCode?: string): string | null {
    if (!phone) return null;

    // If countryCode is provided, normalize the phone with DDI
    if (countryCode) {
        const normalized = normalizePhoneForStorage(phone, countryCode);
        return normalized;
    }

    // If no country code, just clean the number (remove all non-digits)
    const cleaned = phone.replace(/\D/g, '');
    return cleaned || null;
}

/**
 * Generate WhatsApp wa.me link
 * @param phone - Phone number
 * @param countryCode - Optional country code for normalization
 * @returns WhatsApp link or null if phone is invalid
 */
export function getWhatsAppLink(phone: string | null | undefined, countryCode?: string): string | null {
    const formatted = formatPhoneForWhatsApp(phone, countryCode);
    if (!formatted) return null;

    return `https://wa.me/${formatted}`;
}
